import React, { useEffect, useState } from "react";
import { useInView } from "../hooks/useInView";

// Splits a string into words and animates each in with an 80ms stagger.
// By default it starts 200ms after mount (for above-the-fold hero use).
// Pass `triggerOnView` for headlines further down the page, so the
// animation plays when the headline actually scrolls into view instead of
// having already finished before anyone sees it.
const AnimatedHeadline = ({ text, className, style, tag: Tag = "h1", triggerOnView = false }) => {
  const words = text.split(" ");
  const [started, setStarted] = useState(false);
  const { ref, inView } = useInView(0.3);

  useEffect(() => {
    if (triggerOnView && !inView) return;
    const timer = setTimeout(() => setStarted(true), 200);
    return () => clearTimeout(timer);
  }, [triggerOnView, inView]);

  const NBSP = " ";

  return (
    <Tag ref={triggerOnView ? ref : undefined} className={className} style={style}>
      {words.map((word, i) => (
        <span
          key={i}
          className={`word ${started ? "animate" : ""}`}
          style={{ animationDelay: `${i * 80}ms` }}
        >
          {word}
          {i < words.length - 1 ? NBSP : ""}
        </span>
      ))}
    </Tag>
  );
};

export default AnimatedHeadline;
